// extracted by mini-css-extract-plugin
export default {"SwatchButton":"SwatchButton","SwatchButton--fill":"SwatchButton--fill","isActive":"isActive"};